export const TYNEMCE = {
  API_KEY: 'ebd3garuwrn2ikyiqy8571rrk1bqnf6iwlg5d2xycn5bk8xz',
  PLUGINS: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount',
  ],
  TOOLBAR: `undo redo | formatselect | bold italic backcolor |
      alignleft aligncenter alignright alignjustify |
      bullist numlist outdent indent | removeformat | help`,
};
